import { pick } from 'lodash-es';

import { defaultValues } from './configurationDefaultValues';
import type { SchemeConfigFormValues } from './PricingWizardSchemeConfigurationStep';
import type { PricingSchemeRead } from 'src/common/external/bambi-api/bambiApi';

export const assignConfigurationDefaultValues = (
  originalPricingSchemeValues?: PricingSchemeRead
): SchemeConfigFormValues => {
  const formDefaultValues: SchemeConfigFormValues = originalPricingSchemeValues
    ? {
        ...defaultValues,
        // These are important to set to undefined so we pick all the fields on edit
        // See pick(originalPricingSchemeValues, Object.keys(defaultValues))
        ...pick(originalPricingSchemeValues, Object.keys(defaultValues)),
      }
    : { ...defaultValues };
  // Again, some extra handling because the backend only uses late_cancellation_fee_cents
  if (formDefaultValues.late_cancellation_fee_type === 'Percentage') {
    formDefaultValues.late_cancellation_fee_percentage =
      formDefaultValues.late_cancellation_fee_percentage ||
      formDefaultValues.late_cancellation_fee_cents ||
      defaultValues.late_cancellation_fee_percentage;
    formDefaultValues.late_cancellation_fee_cents =
      defaultValues.late_cancellation_fee_cents;
  }

  // And likewise with no show fee
  if (formDefaultValues.no_show_fee_type === 'Percentage') {
    formDefaultValues.no_show_fee_percentage =
      formDefaultValues.no_show_fee_percentage ||
      formDefaultValues.no_show_fee_cents ||
      defaultValues.no_show_fee_percentage;
    formDefaultValues.no_show_fee_cents = defaultValues.no_show_fee_cents;
  }

  return formDefaultValues;
};
